export default {"src":"/_next/static/media/0x5a7a183b6b44dc4ec2e3d2ef43f98c5152b1d76d.893ce48e.svg","height":498,"width":498,"blurWidth":0,"blurHeight":0};